import React, { Suspense } from "react";

type LazyPublicRouteProps = {
  component: React.LazyExoticComponent<React.ComponentType<any>>;
};

const LazyPublicRoute = ({ component: Component }: LazyPublicRouteProps) => (
  <Suspense fallback={null}>
    <Component />
  </Suspense>
);

export default LazyPublicRoute;
